import React from "react";

const TrustLogos = () => {
  // Technology partner/trust logos
  const logos = [
    { name: "Microsoft", icon: "M" },
    { name: "Apple", icon: "" },
    { name: "Google", icon: "G" },
    { name: "Windows", icon: "⊞" },
    { name: "Android", icon: "🤖" },
    { name: "iOS", icon: "📱" },
  ];

  return (
    <section className="py-10 md:py-14 bg-muted/30 border-y border-border overflow-hidden">
      <div className="mx-auto max-w-7xl px-6">
        <p className="text-center text-sm font-medium text-muted-foreground tracking-wider uppercase mb-8">
          Wir unterstützen alle gängigen Systeme
        </p>
        
        {/* Scrolling logos container */}
        <div className="relative">
          <div className="flex items-center justify-center gap-12 md:gap-16 flex-wrap md:flex-nowrap">
            {logos.map((logo, i) => (
              <div 
                key={i}
                className="flex items-center gap-3 text-muted-foreground/60 hover:text-muted-foreground transition-colors"
              >
                <span className="text-2xl md:text-3xl">{logo.icon}</span>
                <span className="text-lg md:text-xl font-semibold tracking-tight">{logo.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustLogos;
